// Module
var code = `<div ng-if="\$ctrl.warnPasswordExpiration" class="alert alert--danger">
  <span>
    Your password expires on {{ \$ctrl.expirationDate | prettyDate }}. Please change your password immediately.
  </span>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/password-expiration-warning/password-expiration-warning.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;